module.exports = __webpack_public_path__ + "img/pumpkin.ad4db025.png";